import { render, staticRenderFns } from "./SearchBlock.vue?vue&type=template&id=3355fe89&scoped=true&"
import script from "./SearchBlock.vue?vue&type=script&lang=js&"
export * from "./SearchBlock.vue?vue&type=script&lang=js&"
import style0 from "./SearchBlock.vue?vue&type=style&index=0&id=3355fe89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355fe89",
  null
  
)

export default component.exports